import { language } from "language/default";
import "./insMapFooter.scss";
import React from "react";
export const InsMapFooter = ({ itemCount }) => React.createElement("div", { className: "ins-map-footer-container" }, language.en.chart.map.footerMessage(itemCount));
